import { DetailCardItemData } from '@/common/components/DetailCard/DetailCard.types.ts';
import convertTimeStampToDate from '@/common/utils/convertTimeStampToDate';
import { FileInformationQuery } from '@/modules/FileDetail/queries/fileInformation/fileInformationQuery.type.ts';
import { css } from 'styled-system/css';

export default (data: FileInformationQuery): DetailCardItemData[] => {
  return [
    {
      type: 'default',
      keyName: 'شماره پرونده',
      value: data.order_id,
      dirLtr: true,
    },
    {
      type: 'tel',
      keyName: 'اعلام کننده',
      value: data.applicant_user_full_name,
      telephone: data.applicant_user_phone_number,
    },
    {
      type: 'default',
      keyName: 'استان و شهر',
      value: `${data.visit_province?.name} - ${data.visit_county?.name} `,
    },

    ...(data.file_type?.const !== 'initial'
      ? [
          {
            type: 'default' as const,
            keyName: 'زمان وقوع',
            value: data.event_happening_date
              ? `${data.event_happening_time} - ${convertTimeStampToDate(data.event_happening_date, { hour: undefined, minute: undefined })}`
              : '',
          },
        ]
      : []),

    {
      type: 'default',
      keyName: 'تاریخ تشکیل',
      value: data.creation_date
        ? convertTimeStampToDate(data.creation_date, {
            hour: undefined,
            minute: undefined,
          })
        : '',
    },
    {
      type: 'default',
      keyName: 'تاریخ قرار‌گیری در وضعیت',
      value: data.action_date
        ? convertTimeStampToDate(data.action_date, {
            hour: undefined,
            minute: undefined,
          })
        : '',
    },
    {
      type: 'default',
      keyName: 'زمان بازدید',
      valueClassName: !data.visit_date
        ? css({ color: 'red-1', textStyle: 'b2' })
        : undefined,
      value: data.visit_date
        ? `${data.visit_time} - ${convertTimeStampToDate(data.visit_date, { hour: undefined, minute: undefined })}`
        : 'تعیین نشده',
    },
    {
      type: 'default',
      keyName: 'آدرس بازدید',
      value: data.visit_location
        ? `${data.visit_location}   ${data.visit_location_detail ? `، ${data.visit_location_detail}` : ''}`
        : '',
    },
  ];
};
